import { Selectbutton } from '@/shared/ui/Selectbutton'
import { useCommonCodes } from '@/shared/lib/codes'
import { figmaLabel } from '@/shared/lib/figmaLabel'
import type { OrgNewDraft } from '@/public/features/org/types'
import { StepHeadLarge } from '@/public/features/org/ui/orgNew/parts'

export function StepCardTarget({ draft }: { draft: OrgNewDraft }) {
  const lifecycle = useCommonCodes('target_lifecycle')
  const situation = useCommonCodes('target_situation')
  const targets = [...(lifecycle.data ?? []), ...(situation.data ?? [])]

  return (
    <section className="flex flex-col gap-8">
      <StepHeadLarge title="해결 대상이 누구인가요?" desc="대상의 특성을 선택해 주세요." />
      <div className="flex flex-wrap content-start gap-3 [&>.ui-selectbutton]:min-w-[150px] [&>.ui-selectbutton]:flex-[1_0_0] [&>.ui-selectbutton]:whitespace-nowrap">
        {targets.map((t) => (
          <Selectbutton
            key={t.code}
            size="lg"
            label={figmaLabel(t.code, t.label)}
            isOn={draft.cardTargetCodes.includes(t.code)}
            onSelect={() => draft.toggleCardTarget(t.code)}
          />
        ))}
      </div>
    </section>
  )
}
